/**
 * Stories implemented by Zillow Navbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent, MouseEvent as ReactMouseEvent } from 'react';
import { HeaderLink } from 'src/components/ZillowNavbar/page-frame-types/HeaderLink';
import { ColumnatedLinkList, FlatLinkList } from 'src/components/ZillowNavbar/page-frame-types/HeaderSubSection';
import { ZillowNavbarNotification } from 'src/components/ZillowNavbar/components/ZillowNavbarNotification';
import { isHeaderLink } from 'src/components/ZillowNavbar/utils/isHeaderLink';
import { isColumnatedLinkList } from 'src/components/ZillowNavbar/utils/isColumnatedLinkList';
import { HeaderLinkDescription } from 'src/components/ZillowNavbar/page-frame-types/HeaderLinkDescription';
import { ZillowNavbarSubSectionLinkAnchorContainer } from './components/ZillowNavbarSubSectionLinkAnchorContainer';
import { ZillowNavbarSubSectionLinksList } from './components/ZillowNavbarSubSectionLinksList';
import { ZillowNavbarSubSectionLinkAnchor } from './components/ZillowNavbarSubSectionLinkAnchor';
import { ZillowNavbarSubSectionLinkDescription } from './components/ZillowNavbarSubSectionLinkDescription';
import { ZillowNavbarSubSectionLinksListGroup } from './components/ZillowNavbarSubSectionLinksListGroup';
import { ZillowNavbarSubSectionLinksColumnatedListContainer } from './components/ZillowNavbarSubSectionLinksColumnatedListContainer';

export type ZillowNavbarSubSectionLinksProps = {
    links: FlatLinkList<HeaderLink> | ColumnatedLinkList<HeaderLink>;
    onLinkClick: (
        link: HeaderLink | HeaderLinkDescription,
        event: ReactMouseEvent<HTMLAnchorElement, MouseEvent>
    ) => void;
};

export const ZillowNavbarSubSectionLinks: FunctionComponent<ZillowNavbarSubSectionLinksProps> = ({
    links,
    onLinkClick,
}) => {
    if (isColumnatedLinkList(links)) {
        return (
            <ZillowNavbarSubSectionLinksListGroup>
                {links.map((sublinks, index) => (
                    // Index sucks as a key but the data doesn't provide a better alternative
                    <ZillowNavbarSubSectionLinksColumnatedListContainer key={index}>
                        <ZillowNavbarSubSectionLinksList>
                            {sublinks.map(linkOrDescription => {
                                if (isHeaderLink(linkOrDescription)) {
                                    return (
                                        <ZillowNavbarSubSectionLinkAnchorContainer key={linkOrDescription.href}>
                                            <ZillowNavbarSubSectionLinkAnchor
                                                onClick={event => onLinkClick(linkOrDescription, event)}
                                                href={linkOrDescription.href}>
                                                {linkOrDescription.text}
                                                {!!linkOrDescription.notifications && (
                                                    <ZillowNavbarNotification>
                                                        {linkOrDescription.notifications}
                                                    </ZillowNavbarNotification>
                                                )}
                                            </ZillowNavbarSubSectionLinkAnchor>
                                        </ZillowNavbarSubSectionLinkAnchorContainer>
                                    );
                                }
                                return (
                                    <ZillowNavbarSubSectionLinkAnchorContainer
                                        key={`${linkOrDescription.text}-${index}`}>
                                        <ZillowNavbarSubSectionLinkDescription>
                                            {linkOrDescription.text}
                                        </ZillowNavbarSubSectionLinkDescription>
                                    </ZillowNavbarSubSectionLinkAnchorContainer>
                                );
                            })}
                        </ZillowNavbarSubSectionLinksList>
                    </ZillowNavbarSubSectionLinksColumnatedListContainer>
                ))}
            </ZillowNavbarSubSectionLinksListGroup>
        );
    }
    return (
        <ZillowNavbarSubSectionLinksList>
            {links.map((linkOrDescription, index) => {
                if (isHeaderLink(linkOrDescription)) {
                    return (
                        <ZillowNavbarSubSectionLinkAnchorContainer key={linkOrDescription.href}>
                            <ZillowNavbarSubSectionLinkAnchor
                                onClick={event => onLinkClick(linkOrDescription, event)}
                                href={linkOrDescription.href}>
                                {linkOrDescription.text}
                                {!!linkOrDescription.notifications && (
                                    <ZillowNavbarNotification>
                                        {linkOrDescription.notifications}
                                    </ZillowNavbarNotification>
                                )}
                            </ZillowNavbarSubSectionLinkAnchor>
                        </ZillowNavbarSubSectionLinkAnchorContainer>
                    );
                }
                return (
                    <ZillowNavbarSubSectionLinkAnchorContainer key={`${linkOrDescription.text}-${index}`}>
                        <ZillowNavbarSubSectionLinkDescription>
                            {linkOrDescription.text}
                        </ZillowNavbarSubSectionLinkDescription>
                    </ZillowNavbarSubSectionLinkAnchorContainer>
                );
            })}
        </ZillowNavbarSubSectionLinksList>
    );
};
